var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButton = void 0;
var ToggleButton_1 = __importDefault(require("./ToggleButton"));
exports.ToggleButton = ToggleButton_1.default;
exports.default = ToggleButton_1.default;
//# sourceMappingURL=index.js.map